import React from "react";
import UsersModal from "./UsersModal";
import ErrorDisplay from "./Error";
import MemberDto from "../../Models/MemberDto";
import { LoaderIcon } from "../Global/Icons";

interface UsersTableFooterAndModalsProps {
  showModal: boolean;
  handleClose: () => void;
  handleSaveUser: (u?: Partial<MemberDto>) => Promise<void> | void;
  editingUser: any;
  existingEmails: string[];
  loading?: boolean;
  errorMsg: string | null;
  setErrorMsg: (msg: string | null) => void;
  onAddMember: (member: MemberDto) => void;
  onSync: () => Promise<void>;
}

const UsersTableFooterAndModals: React.FC<UsersTableFooterAndModalsProps> = ({
  showModal,
  handleClose,
  handleSaveUser,
  editingUser,
  existingEmails,
  loading,
  errorMsg,
  setErrorMsg,
  onAddMember,
  onSync,
}) => (
  <>
    <UsersModal
      show={showModal}
      onHide={handleClose}
      onSave={handleSaveUser}
      initialUser={editingUser}
      existingEmails={existingEmails}
      onAddMember={onAddMember}
      onSync={onSync}
    />
    {loading && (
      <div className="d-flex justify-content-center align-items-center" style={{ height: 200 }}>
        <LoaderIcon />
      </div>
    )}
    {errorMsg && (
      <div style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(0,0,0,0.35)",
        zIndex: 2000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}>
        <div style={{ minWidth: 350, maxWidth: 500, background: "#fff", borderRadius: 12, boxShadow: "0 2px 16px rgba(0,0,0,0.18)", padding: 32 }}>
          <ErrorDisplay
            title="Error"
            text={errorMsg}
            onClose={() => setErrorMsg(null)}
          />
        </div>
      </div>
    )}
  </>
);

export default UsersTableFooterAndModals;

